export var CLAN_PERMISSION_TEMPLATE_IDS = ["recruiter", "searchManager", "coAdmin", "admin"];
export var CLAN_PERMISSION_TEMPLATES = {
    recruiter: {
        readMatchs: true,
        readClanSearchFilter: true,
        createPlayersOnClan: true,
    },
    searchManager: {
        readClanSearchFilter: true,
        createClanSearchFilter: true,
        updateClanSearchFilter: true,
        readClanApiSearchFilter: true,
        createClanApiSearchFilter: true,
        updateClanApiSearchFilter: true,
        readClanPersonalSearchFilter: true,
        createClanPersonalSearchFilter: true,
        updateClanPersonalSearchFilter: true,
    },
    coAdmin: {
        createClanSearchFilter: true,
        readClanSearchFilter: true,
        updateClanSearchFilter: true,
        deleteClanSearchFilter: true,
        createClanApiSearchFilter: true,
        readClanApiSearchFilter: true,
        updateClanApiSearchFilter: true,
        deleteClanApiSearchFilter: true,
        createClanPersonalSearchFilter: true,
        readClanPersonalSearchFilter: true,
        updateClanPersonalSearchFilter: true,
        deleteClanPersonalSearchFilter: true,
        createPlayersOnClan: true,
        deletePlayersOnClan: true,
        readMatchs: true,
        updateMatchDecisions: true,
        readClanConfig: true,
        updateClanConfig: true,
    },
    admin: {
        admin: true,
    },
};
